var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 120,
    viewBox: "0 0 155 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21990_49089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1953 119.696C25.1953 119.865 25.288 120.001 25.4035 120.001H129.205C129.321 120.001 129.413 119.865 129.413 119.696C129.413 119.527 129.32 119.391 129.205 119.391H25.4035C25.288 119.391 25.1953 119.527 25.1953 119.696Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9014 118.688H59.1953V119.342H62.9014V118.688Z",
    fill: "#9A9FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7139 118.797H92.0078V119.451H95.7139V118.797Z",
    fill: "#9A9FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7671 89.5625C82.5607 90.8119 81.9178 91.9474 80.9529 92.7666C79.9879 93.5858 78.7637 94.0354 77.4984 94.0354C76.233 94.0354 75.0088 93.5858 74.0438 92.7666C73.0789 91.9474 72.436 90.8119 72.2296 89.5625H58.75V118.798H96.2473V89.5625H82.7671Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3559 116.477H58.8594V117.494H96.3559V116.477Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.91 90.3252H2.09038C1.53617 90.3246 1.00483 90.104 0.612939 89.7118C0.22105 89.3196 0.000616137 88.7878 0 88.2331L0 2.09224C0.000564798 1.53755 0.220976 1.00574 0.612871 0.613497C1.00477 0.221253 1.53613 0.00061672 2.09038 0H152.91C153.464 0.000667902 153.995 0.221294 154.387 0.613484C154.779 1.00567 154.999 1.53741 155 2.09205V88.2331C154.999 88.7878 154.779 89.3195 154.387 89.7117C153.995 90.1039 153.464 90.3245 152.91 90.3252Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 3.29688H3.51172V86.6404H151.1V3.29688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.449 55.2169H49.7707C49.3261 55.2164 48.8999 55.0394 48.5855 54.7248C48.2711 54.4102 48.0943 53.9836 48.0938 53.5386V34.7408C48.0943 34.2959 48.2711 33.8693 48.5855 33.5546C48.8999 33.24 49.3261 33.063 49.7707 33.0625H105.449C105.893 33.063 106.319 33.24 106.634 33.5546C106.948 33.8693 107.125 34.2959 107.125 34.7408V53.5386C107.125 53.9836 106.948 54.4102 106.634 54.7248C106.319 55.0394 105.893 55.2164 105.449 55.2169Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1825 38.7656H57.2005C56.9862 38.7656 56.8125 38.9395 56.8125 39.1539V40.0557C56.8125 40.2701 56.9862 40.444 57.2005 40.444H71.1825C71.3968 40.444 71.5705 40.2701 71.5705 40.0557V39.1539C71.5705 38.9395 71.3968 38.7656 71.1825 38.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0257 40.7796C91.5814 40.7796 92.0319 40.3288 92.0319 39.7726C92.0319 39.2165 91.5814 38.7656 91.0257 38.7656C90.47 38.7656 90.0195 39.2165 90.0195 39.7726C90.0195 40.3288 90.47 40.7796 91.0257 40.7796Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3812 40.7796C94.9369 40.7796 95.3874 40.3288 95.3874 39.7726C95.3874 39.2165 94.9369 38.7656 94.3812 38.7656C93.8255 38.7656 93.375 39.2165 93.375 39.7726C93.375 40.3288 93.8255 40.7796 94.3812 40.7796Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7328 40.7796C98.2885 40.7796 98.739 40.3288 98.739 39.7726C98.739 39.2165 98.2885 38.7656 97.7328 38.7656C97.1771 38.7656 96.7266 39.2165 96.7266 39.7726C96.7266 40.3288 97.1771 40.7796 97.7328 40.7796Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.124 63.1664C111.511 63.1664 115.068 59.6069 115.068 55.216C115.068 50.8251 111.511 47.2656 107.124 47.2656C102.736 47.2656 99.1797 50.8251 99.1797 55.216C99.1797 59.6069 102.736 63.1664 107.124 63.1664Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.424 56.6997L106.322 50.9531H107.922L107.815 56.6997H106.424ZM107.125 59.4772C107.003 59.4814 106.882 59.4612 106.769 59.4179C106.655 59.3745 106.551 59.3089 106.464 59.2248C106.378 59.1428 106.311 59.0438 106.266 58.9342C106.222 58.8246 106.2 58.7068 106.204 58.5884C106.199 58.4687 106.22 58.3494 106.265 58.2382C106.31 58.1271 106.377 58.0267 106.464 57.9435C106.552 57.8604 106.656 57.7956 106.769 57.7528C106.883 57.7101 107.004 57.6903 107.125 57.6946C107.246 57.6903 107.367 57.7101 107.48 57.7528C107.594 57.7956 107.698 57.8604 107.786 57.9435C107.872 58.0267 107.94 58.1271 107.985 58.2382C108.03 58.3494 108.051 58.4687 108.046 58.5884C108.05 58.7068 108.028 58.8246 107.984 58.9342C107.939 59.0438 107.872 59.1428 107.786 59.2248C107.698 59.3089 107.595 59.3744 107.481 59.4178C107.367 59.4611 107.246 59.4814 107.125 59.4772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21990_49089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload-error.4aba94a0ef4f4b4eedfe4a55482bf26d.svg";
export { ForwardRef as ReactComponent };